import { Breadcrumbs, LinearProgress, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { InstalledAppDetails } from "../installedAppDetail";
import { useInstalledAppDetail } from "../hooks/useInstalledAppDetail";

export const InstalledAppDetailTemplate: React.FC = () => {
  const { appDetail, isLoading } = useInstalledAppDetail();

  return (
    <>
      {appDetail && !isLoading ? (
        // 連携アプリ詳細が取得できている
        <>
          <Breadcrumbs>
            <Link to="/manager/installed-applications">連携アプリ一覧</Link>
            <Typography>{appDetail.name}</Typography>
          </Breadcrumbs>

          <InstalledAppDetails
            name={appDetail.name}
            description={appDetail.description}
            productId={appDetail.productId}
            type={appDetail.type}
            uri={appDetail.uri}
          />
        </>
      ) : (
        // ロード中・取得に失敗
        <>
          <Breadcrumbs>
            <Link to="/manager/installed-applications">連携アプリ一覧</Link>
            <Typography>-</Typography>
          </Breadcrumbs>

          {
            // ロード中ならSuspenseライクなコンポーネントを表示させる
            isLoading && (
              <>
                <InstalledAppDetails
                  name=""
                  description=""
                  productId=""
                  type=""
                  uri=""
                  isLoading
                />
                <LinearProgress />
              </>
            )
          }
        </>
      )}
    </>
  );
};
